<!-- <h6>{{ tenant.Name }} Environments</h6> -->
<kendo-grid
  #grid
  [data]="view | async"
  [style.height.%]="100"
  [pageSize]="gridState.take"
  [skip]="gridState.skip"
  [sort]="gridState.sort"
  [pageable]="true"
  [sortable]="true"
  (dataStateChange)="onStateChange($event)"
  (edit)="editHandler($event)"
  (cancel)="cancelHandler($event)"
  (save)="saveHandler($event)"
  (remove)="removeHandler($event)"
  (add)="addHandler($event)"
  [navigable]="true"
  [loading]="loading"
  [resizable]="true"
>
  <ng-template kendoGridToolbarTemplate>
    <button class="btn btn-primary" kendoGridAddCommand>
      <fa-icon icon="plus"></fa-icon>
      <!-- Add {{ tenant.Name }} to an Environment -->
    </button>
  </ng-template>
  <kendo-grid-column
    field="Id"
    title="ID"
    width="100"
    [editable]="false"
    [hidden]="true"
  >
  </kendo-grid-column>
  <kendo-grid-column
    field="TenantId"
    title="Tenant ID"
    width="100"
    [editable]="false"
    [hidden]="true"
  >
  </kendo-grid-column>  
  <kendo-grid-column
    field="EnvironmentId"
    title="Environemnt ID"
    width="100"
    [editable]="false"
    [hidden]="true"
  >
  </kendo-grid-column>

  <kendo-grid-column field="EnvironmentId" title="Environment Name">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <span>{{ environmentMap[dataItem.EnvironmentId] }}</span>
    </ng-template>
    <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup" let-isNew="isNew">
      <kendo-dropdownlist
        [formControl]="formGroup.get('EnvironmentId')"
        [valuePrimitive]="true"
        [data]="environments"
        [textField]="'Name'"
        [valueField]="'Id'"
      ></kendo-dropdownlist>
      <div #anch style="height: 1px;"></div>
      <kendo-popup
        [anchor]="anch"
        *ngIf="formGroup.get('EnvironmentId').invalid && !(isNew && formGroup.get('EnvironmentId').untouched)"
        popupClass="k-widget k-tooltip k-tooltip-validation k-invalid-msg"
       >
       <div *ngIf="formGroup.get('EnvironmentId').hasError('unique')">
        <span class="k-icon k-i-warning"></span>
        Environment is already associated with this tenant
       </div>         
      </kendo-popup>      
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-command-column title="" width="200">
    <ng-template kendoGridCellTemplate let-isNew="isNew">
      <button class="btn btn-danger" kendoGridRemoveCommand>
        <fa-icon icon="trash"></fa-icon>
      </button>
      <button
        class="btn btn-primary"
        kendoGridSaveCommand
        [disabled]="formGroup?.invalid"
      >
        <fa-icon icon="check"></fa-icon>
      </button>
      <button class="btn btn-secondary" kendoGridCancelCommand>
        <fa-icon icon="times"></fa-icon>
      </button>
    </ng-template>
  </kendo-grid-command-column>
  <div *kendoGridDetailTemplate="let dataItem">
    <app-environment-services
      [tenantEnvironment]="dataItem"
    ></app-environment-services>
  </div>
</kendo-grid>
